import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=38ec249a&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=38ec249a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec249a",
  null
  
)

export default component.exports